import { render, staticRenderFns } from "./choiceCompany.vue?vue&type=template&id=83ef9426"
import script from "./choiceCompany.vue?vue&type=script&lang=js"
export * from "./choiceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports